// extracted by mini-css-extract-plugin
module.exports = {"card":"slideList_card__0nhGA","visible":"slideList_visible__fQ0vm","hidden":"slideList_hidden__ulJs1","hide":"slideList_hide__dCEWW","list":"slideList_list__uUnFr"};